<template>
  <div class="card summary-card">
    <div class="card-header">
      <div class="media align-items-center">
        <div class="media-left">
          <v-icon
            icon="mdi-card-account-details-outline"
            color="black"
          />
          <!-- <font-awesome-icon :icon="['far', 'id-card']" fixed-width /> -->
        </div>
        <div class="media-body flex-row align-items-center">
          <h3 class="summary-name">
            Patient Details <span v-if="patientType">[ {{ patientType }} ]</span>
          </h3>
        </div>
      </div>
    </div>
   

    <div class="card-body">
      <div
        class="summary-items"
        title="Details"
      >
        <div class="summary-list">
          <dl>
            <dt>TGLN ID</dt>
            <dd>{{ getTglnId( patient ) }}</dd>
          </dl>
          <dl>
            <dt>First Name</dt>
            <dd>{{ getName( patient ).firstName }}</dd>
          </dl>
          <dl>
            <dt>Last Name</dt>
            <dd>{{ getName( patient ).lastName }}</dd>
          </dl>
          <dl v-if="patient.birthDate">
            <dt>Date of Birth</dt>
            <dd>{{ patient.birthDate }}</dd>
          </dl> 
          <dl>
            <dt>Sex</dt>
            <dd>{{ patient.gender }}</dd>
          </dl>
          <dl>
            <dt>Age</dt>
            <dd> {{ calculateAge( patient.birthDate ) }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PATIENT_TYPES } from '@/constants';

export default {
  name: "PatientDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientType:{
      type: String,
      default: null
    }
  },
  data() {
    return {
    };
    },
   mounted() {
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    calculateAge( birthDate ) {
      let age = Math.floor( ( new Date() - new Date( birthDate ) ) / 31536000000 );
      return age;
    },
    getTglnId( patient ) {
      let identifier_type="TGLNRecipient"; // By default, it was already recipient, so keeping it as that for now.
      switch( this.patientType ){
        case PATIENT_TYPES.DONOR.name:
          identifier_type = "TGLNDonor";
          break;
        case PATIENT_TYPES.RECIPIENT.name:
          identifier_type = "TGLNRecipient";
          break;
      }
      let tglnId = patient.identifier.filter( ( n ) => ( n.use === 'usual' && n.type?.text === identifier_type ) ) ;
      return tglnId[0]?.value ? tglnId[0]?.value : '--' ;
    },
    getName( patient ) {
      let fullName = patient.name.filter( ( n ) => ( n.use === 'official' ) ) ;
      let firstName = '';
      let lastName = '';
      if( fullName[0] && fullName[0].given && fullName[0].family ) {
        lastName = fullName[0].family;
        firstName = fullName[0].given?.[0];
      }
      let name = { 'firstName': firstName, "lastName": lastName };
      return name;
    }
  },
};
</script>

<style scoped>

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 600;
}

</style>
